module.exports = __webpack_public_path__ + "img/bronze.c7a86998.png";